import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BadImplementationException, exists, MUSTNeverHappenException } from '@nu-art/ts-common';
import { DataGrid, QuaiManager_DropDownCaret } from '@app/styles';
import { Component_SwitchView } from '@nu-art/permissions-frontend/ui/Component_SwitchView';
import { ModuleFE_Action } from '../../../../../_entity.js';
import { DropDown_VariableV3WithSynonyms, HCSDropDowns, ModuleFE_Resource, ModuleFE_Variable } from '@app/hcs-frontend';
import { DropDown_AdvisorWizard } from '@app/advisor-content-frontend/_entity/wizard/ui-components';
import { ModuleFE_AdvisorWizard } from '@app/advisor-content-frontend/_entity';
import { TS_EditableItemComponent } from '@nu-art/thunderstorm-frontend/editable-item';
import { TS_Checkbox } from '@nu-art/thunderstorm-frontend/index';
const RenderKey_Edit = 'edit';
const RenderKey_View = 'view';
export class Renderer_ActionData_Order extends TS_EditableItemComponent {
    deriveStateFromProps(nextProps, state) {
        if (!ModuleFE_Action.is.order(nextProps.editable.item))
            throw new BadImplementationException('Passed non order action!');
        state = super.deriveStateFromProps(nextProps, state);
        state.editMode = nextProps.editMode;
        return state;
    }
    // ######################## Logic ########################
    getRenderKey = () => {
        return this.state.editMode ? RenderKey_Edit : RenderKey_View;
    };
    // ######################## Render ########################
    render() {
        return _jsxs(_Fragment, { children: [this.renderRelatedResource(), this.renderRelatedSnippet(), this.renderRelatedVariable(), this.renderIsOrderSet()] });
    }
    renderRelatedResource = () => {
        const order = this.state.editable;
        return _jsxs(_Fragment, { children: [_jsx(DataGrid.Label, { children: "Related Resource" }), _jsx(Component_SwitchView, { mode: this.getRenderKey(), modes: [
                        {
                            key: RenderKey_View,
                            renderer: () => {
                                const resource = ModuleFE_Resource.cache.unique(order.item.resourceId);
                                if (order.item.resourceId && !resource)
                                    throw new MUSTNeverHappenException(`Could not get resource for resourceId ${order.item.resourceId}`);
                                return _jsx(DataGrid.Data, { children: resource?.label ?? '-' });
                            }
                        },
                        {
                            key: RenderKey_Edit,
                            renderer: () => _jsx(HCSDropDowns.Resource, { selected: order.item.resourceId, showErrorTooltip: true, onSelected: async (resource) => {
                                    await this.state.editable.updateObj({
                                        resourceId: resource._id,
                                        variableId: undefined,
                                    });
                                    this.forceUpdate();
                                }, caret: QuaiManager_DropDownCaret })
                        }
                    ] })] });
    };
    renderRelatedSnippet = () => {
        const order = this.state.editable;
        return _jsxs(_Fragment, { children: [_jsx(DataGrid.Label, { children: "Related Wizard" }), _jsx(Component_SwitchView, { mode: this.getRenderKey(), modes: [
                        {
                            key: RenderKey_View,
                            renderer: () => {
                                const wizard = ModuleFE_AdvisorWizard.cache.unique(order.item.wizardId);
                                return _jsx(DataGrid.Data, { children: wizard?.label ?? '-' });
                            }
                        },
                        {
                            key: RenderKey_Edit,
                            renderer: () => _jsx(DropDown_AdvisorWizard.editable, { editable: order, prop: 'wizardId', sortBy: ['label'], canUnselect: true, showErrorTooltip: true, limitItems: 50, onSelected: wizard => {
                                    if (!wizard)
                                        return order.updateObj({ wizardId: undefined });
                                    return order.updateObj({ wizardId: wizard._id });
                                }, caret: QuaiManager_DropDownCaret })
                        }
                    ] })] });
    };
    renderRelatedVariable = () => {
        const action = this.state.editable;
        const resource = ModuleFE_Resource.cache.unique(action.item.resourceId);
        if (action.item.resourceId && !resource)
            throw new MUSTNeverHappenException(`could not find a resource for id ${action.item.resourceId}`);
        return _jsxs(_Fragment, { children: [_jsx(DataGrid.Label, { children: "HCS Variable" }), _jsx(Component_SwitchView, { mode: this.getRenderKey(), modes: [
                        {
                            key: RenderKey_View,
                            renderer: () => {
                                const variable = ModuleFE_Variable.cache.unique(action.item.variableId);
                                if (action.item.variableId && !variable)
                                    throw new MUSTNeverHappenException(`Could not get variable for variableId ${action.item.variableId}`);
                                return _jsx(DataGrid.Data, { children: variable?.name ?? '-' });
                            }
                        },
                        {
                            key: RenderKey_Edit,
                            renderer: () => _jsx(DropDown_VariableV3WithSynonyms.editable, { editable: action, prop: 'variableId', disabled: !resource, showErrorTooltip: true, sortBy: ['_nameInLowercase'], queryFilter: variable => exists(resource) && variable._tagIds.includes(resource.tagId), caret: QuaiManager_DropDownCaret })
                        }
                    ] })] });
    };
    renderIsOrderSet = () => {
        const order = this.state.editable;
        return _jsxs(_Fragment, { children: [_jsx(DataGrid.Label, { children: "Order Set" }), _jsx(Component_SwitchView, { mode: this.getRenderKey(), modes: [
                        {
                            key: RenderKey_View,
                            renderer: () => _jsx(DataGrid.Data, { children: order.item.isOrderSet ? 'Yes' : 'No' })
                        },
                        {
                            key: RenderKey_Edit,
                            renderer: () => _jsx(TS_Checkbox, { checked: order.item.isOrderSet, onCheck: async (checked) => {
                                    await order.updateObj({ isOrderSet: checked });
                                } })
                        }
                    ] })] });
    };
}
//# sourceMappingURL=Renderer_ActionData_Order.js.map